import { gql } from '@apollo/client/core'

import {
  SERVER_ERROR,
  UNAUTHENTICATED_ERROR,
  UNAUTHORIZED_ERROR
} from '@base/api/fragments/errors'

export const LIST_CLUBS_FOR_CLUB_PICKER_QUERY = gql`
  ${SERVER_ERROR}
  ${UNAUTHENTICATED_ERROR}
  ${UNAUTHORIZED_ERROR}

  query listClubsForClubPicker(
    $filter: ListClubsFilter!
    $sortField: ClubSortField!
    $sortOrder: SortOrder!
    $offset: Int
    $limit: Int
  ) {
    listClubs(
      filter: $filter
      sort: [{ sortField: $sortField, sortOrder: $sortOrder }]
      offset: $offset
      limit: $limit
    ) {
      ... on ListClubsOutput {
        clubs {
          id
          clubName
          city
          isNonGolf
        }
        count
      }
      ... on ListClubsErrorOutput {
        errors {
          clubName
          sort
          limit
          offset
        }
      }
      ...UnauthenticatedError
      ...UnauthorizedError
      ...ServerError
    }
  }
`
